import form from 'assets/brands/mosaik/js/page/dashboard/form'
import pagination from 'assets/brands/mosaik/js/page/dashboard/pagination'
import reset from 'assets/brands/mosaik/js/page/dashboard/reset'
import selects from 'assets/brands/mosaik/js/page/dashboard/selects'
import sorting from 'assets/brands/mosaik/js/page/dashboard/sorting'

document.addEventListener('DOMContentLoaded', function () {
  const currentPageType = document.body.getAttribute('data-pagetype') as string

  if (/ce-dashboard/.test(currentPageType)) {
    selects()
    form()
    pagination()
    reset()
    sorting()
  }
})
